// @flow
import React, { Component } from 'react';
import { Watch } from 'scrollmonitor-react';
import styles from '../../../plugins/OfferList/styles.scss';
import eliteStyles from './styles.scss';
import { Container, Row, Col } from 'Components/Grid';
import Price from 'Components/Price';
import classNames from 'classnames';
import { MODAL_TYPES } from 'Containers/ContactForm/contactFormConstants';
import { withRouter } from 'react-router-dom';
import { withUrlParams } from 'Utils/withUrlParams';
import { exchangeLabelIfNecessary } from 'Utils/getButtonLabel';
import { getAdjustedModalType } from 'Utils/getModalType';
import TireLabelModal from './tireLabelModal';
import FocusedImage from 'Components/FocusedImage';
import Button from 'Components/Button';
import Typography from 'Components/Typography';

type Props = {
  alternateColors: boolean,
  background: string,
  hasForm?: () => void, // no in use
  id: any,
  isInViewport: boolean,
  offer: {
    copy: string,
    externalId: string,
    footnote: string,
    hasTireLabel: boolean,
    headline1: string,
    headline2: string,
    image: Object,
    isOsbOffer: boolean,
    price: string,
    priceInfo: string,
  },
  onOpenContact?: () => void, // no in use
  setSharedState: () => void,
  sharedState: Object,
  stopWatcher?: () => void,
  updateMultipleUrlQuery: () => void,
};

class EliteServiceOfferDeprecated extends Component<Props> {
  // @see https://github.com/facebook/react/issues/12670
  state = { isOpen: false };

  static getDerivedStateFromProps(props: Props) {
    if (props.isInViewport) {
      props.stopWatcher();
    }

    return null;
  }

  renderHeadline = (headline1, headline2) => (
    <Row>
      <Col>
        <Typography.Headline
          level="h2"
          forceUppercase={true}
          className={eliteStyles.headline}
          ariaLabel={`${headline1} ${headline2 ?? ''}`.trim()}
          levelVisually="h3"
          value={
            <>
              {headline1}
              {headline2 && <span className={eliteStyles.break}>{headline2}</span>}
            </>
          }
        />
      </Col>
    </Row>
  );

  render() {
    const {
      alternateColors,
      background,
      id,
      isInViewport,
      offer,
      setSharedState,
      sharedState,
      updateMultipleUrlQuery,
    } = this.props;

    const { isOpen } = this.state;

    const {
      copy,
      externalId,
      footnote,
      hasTireLabel,
      headline1,
      headline2,
      image,
      isOsbOffer,
      offerCategory,
      price,
      priceInfo,
    } = offer;

    const priceWrapperClassNames = [styles.priceWrapper, eliteStyles.priceWrapper];
    let tireLabelSrc = '';

    if (hasTireLabel) {
      priceWrapperClassNames.push(eliteStyles.priceWrapperWithTireLogo);
      tireLabelSrc = `https://mazda-editiertool2.elite-consulting.eu/api/publicasset/serveofferimage/${externalId}?returnSecondaryImage=true`;
    }

    if (image) {
      image.alt = `${headline1} ${headline2}`;
    }

    const { isOsbUser, isSalesPartner, isServicePartner } = window.dealer.settings;

    const className = classNames(styles.entry, {
      [eliteStyles.entry]: true,
      [background]: true,
      [styles.isInViewport]: isInViewport || window.isPreview,
      [styles.alternateColors]: alternateColors,
    });

    const priceInfoText = priceInfo.slice(0, priceInfo.endsWith('€') ? -1 : priceInfo.length);

    // Compact variant witout image and description
    if (offerCategory === 'LureOffer') {
      return (
        <div className={className} id={id}>
          <Container>
            {this.renderHeadline(headline1, headline2)}
            <Row align="center">
              <Col cols={3}>
                <Price value={price.replace('.', ',')} showZero dark />
                <span className={eliteStyles.price}>{footnote}</span>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return (
      <div className={className} id={id}>
        <Container>
          {this.renderHeadline(headline1, headline2)}
          <Row align="center">
            <Col m={6}>
              <div className={classNames([styles.image, eliteStyles.image])}>
                <FocusedImage image={image} useThumb={'L'} />
              </div>
            </Col>

            <Col m={6}>
              <Row>
                <Col m={12}>
                  <div
                    className={classNames([styles.text, eliteStyles.text])}
                    dangerouslySetInnerHTML={{ __html: copy }}
                  />
                </Col>

                <Col m={6}></Col>

                <Col m={6} className={classNames(priceWrapperClassNames)}>
                  {hasTireLabel && (
                    <div>
                      <TireLabelModal
                        isOpen={isOpen}
                        onClose={() => this.setState({ isOpen: false })}
                        tireLabelSrc={tireLabelSrc}
                      />
                      <div
                        className={eliteStyles.tyreImageWrapper}
                        onClick={() => this.setState({ isOpen: true })}
                      >
                        <FocusedImage
                          className={eliteStyles.tireLabel}
                          image={{ src: tireLabelSrc, alt: 'Reifenlabel' }}
                        />
                        <div className={eliteStyles.zoomButton}>
                          <Button icon="zoom" />
                        </div>
                      </div>
                    </div>
                  )}
                </Col>

                <Col m={12} className={classNames(priceWrapperClassNames)}>
                  <div className={eliteStyles.priceInfoWrapper}>
                    <span className={eliteStyles.priceInfo} aria-label={priceInfoText}>
                      {priceInfoText}
                    </span>
                    {priceInfo.toLowerCase() === 'kostenlos' || !price ? (
                      ''
                    ) : (
                      <Price value={price.replace('.', ',')} showZero dark />
                    )}
                  </div>
                </Col>

                <Col m={12} className={classNames([styles.priceWrapper, eliteStyles.priceWrapper])}>
                  <span className={eliteStyles.price}>{footnote}</span>
                </Col>

                <div className={eliteStyles.buttonwrapper}>
                  <Button
                    small
                    label={exchangeLabelIfNecessary(
                      '---',
                      getAdjustedModalType({
                        isOsbUser,
                        isSalesPartner,
                        isServicePartner,
                        initialModalType: isOsbOffer
                          ? MODAL_TYPES.ONLINE_SERVICE_BOOKING.name
                          : MODAL_TYPES.SERVICE_REQUEST.name,
                      })
                    )}
                    trackingLabel={`Werkstattterminanfrage-Model: ${sharedState.carModel}, Angebot: ${headline1} ${headline2}`}
                    onClick={() => {
                      setSharedState('serviceangebot', `${headline1} ${headline2}`);
                      updateMultipleUrlQuery({
                        modaltype: isOsbOffer
                          ? MODAL_TYPES.ONLINE_SERVICE_BOOKING.name
                          : MODAL_TYPES.SERVICE_REQUEST.name,
                        showmodal: 'true',
                      });
                    }}
                  />
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(withUrlParams(Watch(EliteServiceOfferDeprecated)));
